export default __webpack_public_path__ + "static/media/regreen_visual_09.4a46ba53.jpg";